import { FeatureKey } from "~/types/subscription";

export const PREMIUM_FEATURE_DESCRIPTIONS: Partial<
  Record<FeatureKey, string>
> = {
  [FeatureKey.SAVE_FILTER]:
    "Save your custom filter setups and instantly switch between them—so you can track your favorite market views without resetting filters every time.",
  [FeatureKey.PROBABILITY_SLIDER]:
    "Quickly narrow down markets by selecting your ideal probability and price range with the Strike Zone slider. Helps to pinpoint high-value opportunities and filter outcomes with precision.",
  [FeatureKey.TWENTY_FOUR_HOUR_ACTIVITY_FILTER]:
    "Filter markets by recent activity using 24h volume and price change to quickly identify high-momentum opportunities. Customize thresholds or use quick presets to surface the most active and fast-moving markets in real time.",
  [FeatureKey.SPREAD_FILTER]:
    "Filter markets by minimum bid-ask spread to quickly identify pricing inefficiencies and wider trading opportunities. Use preset thresholds or custom values to surface markets where spreads meet your strategy criteria.",
  [FeatureKey.APY_FILTER]:
    "Filter markets by annualized return to quickly identify high-yield opportunities based on current pricing and time to resolution.",
  [FeatureKey.ROI_FILTER]:
    "Filter markets by total return to focus on opportunities with the highest potential profit from entry to resolution.",
};

export const getPremiumFeatureDescription = (
  featureKey: FeatureKey,
  availableOnPlan: string
) =>
  PREMIUM_FEATURE_DESCRIPTIONS[featureKey] ??
  `Available on ${availableOnPlan} plan and above.`;
